import { Router } from './router';
import { AuthService } from './services/auth.service';
import './styles/app.scss';

const router = new Router(
    [
        { path: '#/login', component: () => import('./features/auth/login.view') },
        { path: '#/app', component: () => import('./features/dashboard/dashboard.view') },
        { path: '#/schema', component: () => import('./features/schema-forms/schema-form.view') },
        { path: '#/photo', component: () => import('./features/uploads/photo-upload.view') },  
        { path: '#/done', component: () => import('./features/done/done.view') },
    ],
    {
        guard: (path) => {
            // consenti il login liberamente
            if (path === '#/login') return path;
            // per tutto il resto richiedi autenticazione
            return AuthService.isAuthenticated() ? path : '#/login';
        }
    }
);

router.start();

// opzionale: rotta di default all�avvio
if (!location.hash) location.hash = AuthService.isAuthenticated() ? '#/app' : '#/login';